import { useDispatch } from 'react-redux';
import { Slice, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { useCallback } from 'react';

export type DispatchedActions<s extends Slice<unknown>> = {
    [k in keyof s['actions']]?: (
        p: Parameters<s['actions'][k]>[0] extends undefined
            ? void
            : Parameters<s['actions'][k]>[0]
    ) => void;
};

export function useDispatchedSliceActions<slice extends Slice<unknown>>() {
    // Slice actions may be async thunks (create.asyncThunk), so dispatch must accept thunks
    const dispatch =
        useDispatch<ThunkDispatch<unknown, unknown, UnknownAction>>();

    return useCallback((actions: slice['actions']) => {
        const dispatchedActions: DispatchedActions<slice> = {};
        for (const key in actions) {
            dispatchedActions[key] = (payload) => {
                dispatch(actions[key](payload));
            };
        }

        return dispatchedActions;
    }, []);
}
